import Company from "@/models/loyaltyPanel/Company";

export default {
    namespaced: true,

    state: () => ({
        notificationsLoading: false,
        notifications: [],
        notificationsPagination: {},
        exportedFile: null,
        exportNotificationFileCreated: false
    }),
    getters: {
        notifications: state => state.notifications,
        exportedFile: state => state.exportedFile,
    },
    mutations: {
        setNotifications(state, payload) {
            state.notifications = payload;
        },
        setNotificationsLoading(state, payload) {
            state.notificationsLoading = payload;
        },
        setNotificationsPagination(state, payload) {
            state.notificationsPagination = payload;
        },
        setExportedFile(state, payload){
            state.exportedFile = payload;
        },
        setExportNotificationFileCreated(state, payload){
            state.exportNotificationFileCreated = payload;
        },
    },

    actions: {
        async getNotifications({ commit, getters, state }, payload) {
            try {
                commit("setLoading", true, { root: true });
                commit("setNotificationsLoading", true);

                const { data } = await Company.getNotifications(payload);

                const { user_notifications,pagination } = data.data;

                for(let i in user_notifications){
                    for(let p in user_notifications[i]){
                        user_notifications[i][p] = user_notifications[i][p] ? user_notifications[i][p]  : '-';
                    }
                }
                commit("setNotifications", user_notifications);
                commit("setNotificationsPagination", pagination);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getExportedFileStatus({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await Company.getNotificationsExportedFileStatus()

                commit("setExportedFile", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async exportFile({ commit }, payload) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await Company.exportNotificationsFile(payload)

                commit("setExportedFile", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, payload) {
            try {
                commit("setLoading", true, { root: true });

                await Company.deleteNotificationsExportedFile(payload.id)

                commit("setExportedFile", null)
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
    }
};
